import React from "react";
import DOMPurify from "dompurify";

interface Props {
  html: string;
}

const PreviewView: React.FC<Props> = ({ html }) => {
  return (
    <div
      style={{ border: "1px solid #ddd", padding: "10px" }}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
    />
  );
};

export default PreviewView;
